import { CreditCardAddress } from '@/types/CreditCard';
import { ShippingQuote } from '@/types/ShippingQuote';

export type ShippingQuoteSlice = {
    byId: { [id: number]: ShippingQuote };
    loaded: { [id: number]: number };
    loading: number[];
};

export const defaultShippingQuoteSlice: ShippingQuoteSlice = {
    byId: {},
    loaded: {},
    loading: [],
};

export type ShippingQuoteInfoType = {
    catalogId: number;
    force?: boolean;
    invoiceId: number;
    itemIds?: number[];
    shippingAddress?: CreditCardAddress;
};

export type FinalShippingQuoteType = {
    authToken: string;
    deployment: string;
    invoiceId: number;
    quoteId: string;
    quoteNumber: string;
};
